import { useEffect, useRef } from "react";
import { detectBarcodeFormat } from "../pages/hdi-scanner-page/hdiScannerPageUtils";
import { extractBasedOnSymbology } from "../helpers/extractBasedOnSymbologyUtils";

const BURST_GAP_THRESHOLD_MS = 100;
const DEBOUNCE_DELAY_MS = 80;

export function useScannerInputDetection(
  currentQueryLength: number,
  onBarcodeDetected: (articleNumber: string) => void
) {
  const scanTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const burstStartTimeRef = useRef<number>(0);
  const burstStartLengthRef = useRef<number>(0);

  useEffect(() => {
    return () => {
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
    };
  }, []);

  const handleInputChange = (value: string) => {
    const now = Date.now();

    if (scanTimeoutRef.current) {
      clearTimeout(scanTimeoutRef.current);
      scanTimeoutRef.current = null;
    }

    if (now - burstStartTimeRef.current > BURST_GAP_THRESHOLD_MS) {
      burstStartLengthRef.current = currentQueryLength;
    }
    burstStartTimeRef.current = now;

    scanTimeoutRef.current = setTimeout(() => {
      const charsAddedInBurst = value.length - burstStartLengthRef.current;
      if (charsAddedInBurst > 4) {
        const detectedBarcode = detectBarcodeFormat(value);
        if (!detectedBarcode || detectedBarcode === "UNKNOWN") {
          return;
        }
        const extracted = extractBasedOnSymbology(detectedBarcode, value);
        if (extracted.articleNumber) {
          onBarcodeDetected(extracted.articleNumber);
        }
      }
    }, DEBOUNCE_DELAY_MS);
  };

  return { handleInputChange };
}
